window.ajaxRequests = [];

$.ajaxSetup({
   complete: (jqXHR, status) => {
       if(typeof Intercom !== "undefined") {
           if (typeof jqXHR.responseJSON !== "undefined") {
               if (typeof jqXHR.responseJSON.intercom !== "undefined" && typeof jqXHR.responseJSON.intercom.events !== "undefined") {
                   jqXHR.responseJSON.intercom.events.forEach(function (event) {
                       Intercom('trackEvent', event);
                   });
               }
           }
       }
   }
});


$(document).ready(function() {
    window.tooltipStart();
    window.initAutoheight();

    window.initTabs();
    $(window).on('resize', initTabs);

    $('[data-tabs] a').on('click', function (e) {
        e.preventDefault();
        $(this).tab('show');
    });

    $('.datepicker').datepicker({
        dateFormat: "dd-mm-yy"
    });

    $('[data-login-as-user-select]').on('change', function () {
        alert('Přihlašuji se za uživatele "' + $(this).find('option[value="' + $(this).val() + '"]').text() + '"');
        window.location.href = '/admin/user/' + $(this).val() + '/login-as-user/';
    });

    window.chosenLoad();
    window.select2Init();

    window.elasticElements();
    window.polarisList.initialize();
    window.activityProgressBar.initialize();
    if (typeof Livewire != 'undefined') {


        Livewire.hook('element.updated', (el, component) => {
            let element = el;
            if ($(el).is("select.chosen-select")) {
                window.setTimeout(function () {
                    chosenUnLoad(element);
                    chosenLoad(element);
                    chosenCleanup();
                }, 200);
            }
        });

        Livewire.hook('element.init', function (el) {
            if ($(el.el).is("select.chosen-select")) {
                chosenUnLoad(el.el);
                chosenLoad(el.el);
            }
            if ($(el.el).is("select.select2")) {
                select2UnLoad(el.el);
                select2Init(el.el)
            }
            chosenCleanup();
        });

        Livewire.hook('morph.updating', function (el) {
            if ($(el.el).is("select.chosen-select")) {
                chosenUnLoad(el.el);
                chosenLoad(el.el);
            }
            if ($(el.el).is("select.select2")) {
                select2UnLoad(el.el);
                select2Init(el.el)
            }
        });

        Livewire.hook('morph.updated', function (el) {
            if ($(el.el).data('select2-init')) {
                chosenUnLoad($($(el.el).data('select2-init')));
                chosenLoad($($(el.el).data('select2-init')));
            }
            if ($(el.el).is("select.chosen-select")) {
                chosenUnLoad(el.el);
                chosenLoad(el.el);
            }
            if ($(el.el).is("select.select2")) {
                select2UnLoad(el.el);
                select2Init(el.el)
            }
        });
    }

    $(document).on('contextmenu', '[data-copy-text-contextmenu]', (e) => {
        e.stopPropagation();
        e.preventDefault();
        let text = $(e.currentTarget).parent().text().trim();

        navigator.permissions.query({name: "clipboard-write"}).then((result) => {
            const copyContent = async (text) => {
                try {
                    await navigator.clipboard.writeText(text);
                } catch (err) {
                    console.error('Failed to copy: ', err);
                }
            }
            copyContent(text);
        });

        return false;
    });

    $(document).on('click', '[data-copy-text]', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let $elm = $(e.currentTarget);
        let text = $(e.currentTarget).parent().text().trim();

        navigator.permissions.query({name: "clipboard-write"}).then((result) => {
            const copyContent = async (text) => {
                try {
                    await navigator.clipboard.writeText(text);
                    $elm.removeClass('fa-copy').addClass('fa-check');
                    window.setTimeout(() => {
                        $elm.removeClass('fa-check').addClass('fa-copy');
                    }, 1000);
                } catch (err) {
                    console.error('Failed to copy: ', err);
                }
            }
            copyContent(text);
        });

    });

        // Livewire.hook('element.updated', (el, component) => {
        //     console.log('test');
        //     if ($(el).is("select.chosen-select")) {
        //         chosenUnLoad(el);
        //         chosenLoad(el);
        //     }
        //     chosenCleanup();
        // });
        //
        // Livewire.hook('message.processed', (message, component) => {
        //     chosenLoad();
        //     chosenCleanup();
        //     window.elasticElements();
        //     window.polarisList.initialize();
        // });


    $(function () {
        // whenever we hover over a menu item that has a submenu
        $('.nav-main .nav-item').on('mouseover', function () {
            var $menuItem = $(this),
                $submenuWrapper = $('> .nav', $menuItem);

            if ($submenuWrapper.length === 0) return;

            // grab the menu item's position relative to its positioned parent
            var menuItemPos = $menuItem.position();

            // place the submenu in the correct position relevant to the menu item
            $submenuWrapper.css({
                top: menuItemPos.top,
                left: menuItemPos.left + Math.round($menuItem.outerWidth())
            });
        });

        $('[data-menu-open]').on('click', function (ev) {
            ev.preventDefault();
            var url = $(this).attr('href');
            var value = $('body').is('.nav-small');
            $.ajax({
                'url': url,
                'data': {
                    'category': 'menu',
                    'value': value ? 1 : 0,
                },
                success: function () {
                    $('body').toggleClass('nav-small');
                }
            });
        });

        activeLazyload();

        $('.input-password-toggle').on('click', function () {
            var input = $(this).parent().find('#password');
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
    });
    $(function () {
        $(".custom-file-input").on("change", function () {
            var fileName = $(this).val().split("\\").pop();
            $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    });

    $(document).ready(() => {
        //console.log($('.product-thumbnail-item'));
        $('.product-thumbnail-item').not('.clone').simpleLightbox({
            sourceAttr: 'data-img',
            alertError: false,
        });
    });

    $(function () {
        $('*[data-href]').on('click', function () {
            window.location = $(this).data("href");
        });
    });

    window.showCardSetting = function ($el) {
        var $content = $el.closest('[data-custom-setting]').find('[data-custom-setting-content]');
        if ($el.is(':checked')) {
            $content.show();
        } else {
            $content.hide();
        }
    };

    window.connectionWizardStepBound = false;
    window.handleConnectionWizardSettingStep = function () {

        if (!window.connectionWizardStepBound) {
            $('[data-custom-setting-show]').on('change', function () {
                showCardSetting($(this));
            });

            $('[data-custom-setting-show]').each(function (i, el) {
                showCardSetting($(el));
            });
        }
    };

    window.connectionStatusBound = false;
    window.handleConnectionStatusNote = function () {
        var element = $("select[name='status']").eq(0);

        if (!connectionStatusBound) {
            connectionStatusBound = true;
            element.change(handleConnectionStatusNote);
        }

        var value = element.val();
        var notes = element.parents("div.form-group").eq(0).find("small");
        notes.each(function () {
            $(this).toggle($(this).attr("status-key") === value);
        });
    };
    $(document).ready(function () {
        if (typeof Livewire == 'undefined') {
            return;
        }
        if ($('body').data('router-name') !== 'connection-import-connection-wizard' && $('body').data('router-name') !== 'connection-export-connection-wizard') {
            return;
        }
        handleConnectionWizardSettingStep();
        //window.connectionWizardStepBound = true;
        Livewire.hook('message.processed', (message, component) => {
            handleConnectionWizardSettingStep();
        });

        handleConnectionStatusNote();
        Livewire.hook('element.updated', (el, component) => {
            handleConnectionStatusNote();
        });
        Livewire.hook('element.initialized', (el, component) => {
            handleConnectionStatusNote();
        });

    });

    $(function () {
        var $items = $('[data-load-number]');

        if ($items.length === 0) {
            return false;
        }

        $items.each(function (i, el) {
            var $item = $(el);
            $item.html('<img width="10" height="10" src="/images/ajax-loader.gif" />');


            var request = $.ajax({
                url: $item.data('load-number'),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                method: $item.data('method') ? $item.data('method') : 'GET',
                data: $item.data('values'),
                success: function (response) {
                    if (response.status === 'success') {

                        if (response.link) {
                            $item.html($('<a/>').prop('href', response.link).html(response.result));
                        } else {
                            $item.html(response.result);
                        }
                    }
                }
            });
            window.ajaxRequests.push(request);
        });
    });

    $(function () {

        var $items = $('[data-component-load]');

        if ($items.length === 0) {
            return false;
        }

        $items.each(function(i, el) {
            var request = $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                method: 'POST',
                url: '/admin/component/load/',
                data: $(el).data('component-load-data'),
                success: function(response) {
                    if (response.status === "success") {
                        $(el).html(response.render);

                        if (response.others.length) {
                            for (var i in response.others) {
                                var other =  response.others[i];
                                $('[' + other['data_attribute'] + ']').html(other['result']);
                            }
                        }
                        window.tooltipStart();
                    }
                }
            });
            window.ajaxRequests.push(request);
        });
    });

    window.stopRequests = function() {
        $.each(window.ajaxRequests, function (i, xhr) {
            xhr.abort();
        });
    };

    $(function () {
        $('a.dropdown-item').on('click', function () {
            window.stopRequests();
        });
    });

// při změně select ve formuláři si uložíme hodnoty do localstorage (chtělo by to dodělat i na inputy, ale zatím to nepotřebuji)
    $(function () {
        $('[data-form-save-id] select').on('change', function () {
            var $form = $(this).closest('[data-form-save-id]');
            var id = $form.data('form-save-id');
            var data = window.localStorage.getItem(id);
            if (data) {
                data = JSON.parse(data);
            } else {
                data = {};
                data['inputs'] = {};
            }

            var inputs = data['inputs'];
            inputs[$(this).prop('name')] = $(this).val();
            data['inputs'] = inputs;
            window.localStorage.setItem(id, JSON.stringify(data));
        });

        var $form = $('[data-form-save-id]');
        if ($form.length) {
            var data = window.localStorage.getItem($form.data('form-save-id'));
            if (data) {
                data = JSON.parse(data);
                $.each(data.inputs, function (key, value) {
                    $form.find('[name="' + key + '"]').val(value);
                });
            }
        }
    });

    $(function () {

        if (!$('[data-langauge-progress-content]').length) {
            return;
        }

        $('[data-langauge-progress-more-info-btn-show], [data-langauge-progress-more-info-btn-hide]').on('click', function (ev) {
            ev.preventDefault()
            $(this).closest('[data-langauge-progress-content]').find('[data-langauge-progress-more-info-box]').toggle();
            $(this).closest('[data-langauge-progress-content]').find('[data-langauge-progress-more-info-btn-show]').toggle();
            $(this).closest('[data-langauge-progress-content]').find('[data-langauge-progress-more-info-btn-hide]').toggle();
        });
    });

    $(function () {
        var $items = $('[data-progress-box-url]');

        var loadBoxes = function ($item) {
            $.ajax({
                url: $item.data('progress-box-url'),
                success: function (data) {
                    $item.html(data.result);
                    setTimeout(function () {
                        $item.css({'opacity': 1});
                        window.tooltipStart();
                    }, 300);

                    // pokud je řádku loader, tak za 5s zkusíme znovu
                    if ($item.find('[data-progress-bar-loader]').length) {
                        setTimeout(function () {
                            loadBoxes($item);
                        }, 5000);
                    }
                }
            });
        };

        $items.each(function (i, el) {
            var $item = $(el);
            loadBoxes($item);
        });

    });

    $(function () {
        $('body').on('change', '[data-select-all-by-key]', function () {
            $('[data-select-key=\'' + $(this).data('select-all-by-key') + '\']:not(:disabled)').prop('checked', $(this).is(':checked')).change();
        });
    });

    $(function () {
        $('body').on('click', '.Polaris-IndexTable__TableRow, .table-select-checkbox', function (e) {
            var $target = $(e.target);
            if (
                $target.is('.Polaris-Badge') ||
                $target.closest('.Polaris-Badge').length ||
                $target.is('a') ||
                $target.closest('a').length ||
                $target.is('.row-action') ||
                $target.closest('.row-action').length ||
                $target.is('.table-select-ignore') ||
                $target.closest('.table-select-ignore').length
            ) {
                return;
            }

            $checkbox = $target.closest('tr').find('td:first-child [type="checkbox"]');
            if ($checkbox.length == 0) {
                return;
            }

            $checkbox.prop('checked', !$checkbox.is(':checked')).change();
        });
    });
});
